import {useState,useEffect,useMemo} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
    updateWelcomeLinks,
    toggleWelcomeLinks
} from '../../settings/settingsSlice'
import {
	updateTrainerPageColors,
	editTrainerPageAddress,
	updateChosenTemplate,
	editBioData,
	editLogo
} from '../../users/usersSlice'
import {
	getTrainerPagesImages,
	editTrainerPageHeader,
	getTrainerPageHeaders,
	editTrainerPageImages
} from '../../../state/trainerPageSlice.js'
import {
	getCustomAppDetails,
	setLogo,
	editCustomApp
} from '../../../state/branding'
import {useWelcomeLinks} from '../../settings/hooks'

import Select from 'react-select'

import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import InputGroup from 'react-bootstrap/InputGroup'
import Popover from 'react-bootstrap/Popover'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'
import css from './AppCustomization.module.css'

import {useDebounceCallback} from '@react-hook/debounce'

import { SketchPicker } from 'react-color'

import {
	capitalize,
	resizeImage,
	envAwarePost,
	validateImageSize
} from '../../../util/util'
import useS3DirectUpload from '../../../hooks/useS3DirectUpload'
import useBranding from '../../../hooks/useBranding'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'

import CenteredLoader from '../../CenteredLoader/CenteredLoader'

import classicImg from "../../../assets/img/trainerPage/classic.png"
import modernImg from "../../../assets/img/trainerPage/modern.png"
import modernV2Img from "../../../assets/img/trainerPage/modernV2.png"
import modernV2WebpImg from "../../../assets/img/trainerPage/modernV2.webp"
import premiumImg from "../../../assets/img/trainerPage/premium.png"
import classicImgWebp from "../../../assets/img/trainerPage/classic.webp"
import modernImgWebp from "../../../assets/img/trainerPage/modern.webp"
import modernV2ImgWebp from "../../../assets/img/trainerPage/modernV2.webp"
import premiumImgWebp from "../../../assets/img/trainerPage/premium.webp"
import Services from './Services/TrainerPageServices'
import fontColorContrast from 'font-color-contrast'

import LiteIOS from '../LiteIOS/LiteIOS'

import useCurrentUser from '../../../hooks/useCurrentUser'

const Templates = ()=>{
	const dispatch = useDispatch()
	const selectedTemplate = useSelector(state=>state.users.current_user.bio_data.chosen_template)

	const templates = [
		{
			title:"Template 1",
			key:'modernV2',
			images:{ base: modernV2Img, compressed: modernV2ImgWebp }
		},{
			title:"Template 2",
			key:'premium',
			images:{ base: premiumImg, compressed: premiumImgWebp }
		},{
			title:"Template 3",
			key:'modern',
			images:{ base: modernImg, compressed: modernImgWebp }
		},{
			title:"Template 4",
			key:'classic',
			images:{ base: classicImg, compressed: classicImgWebp }
		}
	]
	const handleChooseTemplate = (value)=>{
		dispatch(updateChosenTemplate(value))
	}

	return (
		<div>
			<strong>Choose a Template</strong>
			<div className="d-flex flex-wrap">
				{templates.map(template=>(
					<div
						onClick={handleChooseTemplate.bind(null,template.key)}
						className={[
							"d-flex flex-column align-items-center border rounded mr-2 mb-2",
							template.key === selectedTemplate ? 'bg-primary text-white' : ''
						].join(' ')}
						key={template.key}
					>
						<strong>{template.title}</strong>
						<picture>
							<source srcset={template.images.compressed} />
							<img 
								width="156" 
								src={template.images.base} 
								alt="modern template" loading="lazy" 
								id="templateModern" data-no-retina 
							/>

						</picture>
					</div>
				))}
			</div>
		</div>
	)
}

const ColorOption = ({text,info,color="#fff",type})=>{
	color = Boolean(color) && color !== 'default' ? color : '#fff'
	const dispatch = useDispatch()
	const handlePickColor = ({hex})=>{
		dispatch(updateTrainerPageColors({[type]:hex}))
	}
	const handleReset = ()=>{
		dispatch(updateTrainerPageColors({[type]:'default'}))
	}
	return (
		<div 
			className="mr-2 mb-2 p-1 border rounded d-flex flex-column" 
			style={{width:'200px',maxWidth:'100%'}}
		>
			<div className="mb-1">{text}</div>
			<small className="d-block mb-1">
				<i className="fa fa-info-circle mr-1"/>
				{info}.
			</small>
			<div className="d-flex mt-auto">
				<OverlayTrigger trigger="click" rootClose overlay={
					<Popover>
						<SketchPicker
							color={color}
							onChangeComplete={handlePickColor}
						/>
					</Popover>
				}>
					<div 
						className="d-flex justify-content-center align-items-center border rounded mr-1" 
						style={{width:'100%',height:'32px',background:color}}
					>
						<span style={{color:fontColorContrast(color)}}>
							Click to edit
						</span>
					</div>
				</OverlayTrigger>
				<Button onClick={handleReset} variant="outline-danger" size="sm">
					reset
				</Button>
			</div>
		</div>
	)
}

const ColorOptions = ()=>{
	const user = useCurrentUser()
	const pageTypeText = (
		user.account_type === 'gym'
		? 'Gym'
		: 'Trainer'
	)
	const options = [
		{
			type:'backgroundColor',
			text:'Background Color',
			info:'this will update the background color of specific page elements',
			color:useSelector(state=>state.users.current_user.bio_data.background_color||"")
		},{
			type:'textButtonColor',
			text:'Text & Button Color',
			info:'this will update specific text colors as well as all button backgrounds',
			color:useSelector(state=>state.users.current_user.bio_data.text_button_color||"")
		},{
			type:'buttonTextColor',
			text:'Button Text Color',
			info:'this will update the text colors inside all buttons',
			color:useSelector(state=>state.users.current_user.bio_data.buttontext_color||"")
		}
	]

	return (
		<div>
			<strong className="d-block">Customize Template Colors</strong>
			<small>
				<em>
					Refresh your personalized {pageTypeText} Page to see updates.
				</em>
			</small>
			<div className="d-flex flex-wrap ">
				{options.map( opt => <ColorOption key={opt.type} {...opt}/> )}
			</div>
		</div>
	)
}

const TrainingOptions = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const show = useSelector(
		state => Boolean(state.users.current_user.bio_data.show_locations)
	)
	const onlineTraining = useSelector(
		state => Boolean(state.users.current_user.bio_data.onlineTraining)
	)
	const inPersonTraining = useSelector(
		state => Boolean(state.users.current_user.bio_data.inPersonTraining)
	)

	const user = useCurrentUser()
	const pageTypeText = (
		user.account_type === 'gym'
		? 'Gym'
		: 'Trainer'
	)

	const handleToggleShow = e => {
		dispatch(editBioData({
			field:'show_locations',
			value:Number(e.target.checked)
		}))
	}

	const handleToggleOnline = e => {
		dispatch(editBioData({
			field:'onlineTraining',
			value:Number(e.target.checked)
		}))
	}

	const handleToggleInPerson = e => {
		dispatch(editBioData({
			field:'inPersonTraining',
			value:Number(e.target.checked)
		}))
	}

	return (
		<div>
			<strong>
				Training Locations
			</strong>
			<div>
				<Form.Switch 
					onChange={handleToggleShow}
					checked={show}
					label={`Show on personalized ${pageTypeText} Page`}
					id="show-training-options-switch"
				/>
				<div>
					<Form.Check 
						onChange={handleToggleOnline}
						checked={onlineTraining}
						label="Online Training"
						id="onlinge-training-check"
					/>
					<Form.Check 
						onChange={handleToggleInPerson}
						checked={inPersonTraining}
						label="In-Person Training"
						id="in-person-training-check"
					/>
				</div>
			</div>
		</div>
	)
}

const Headline = ()=>{
	const dispatch = useDispatch()
	const headline = useSelector(state=>state.users.current_user.bio_data.headline)
	const handleBlur = (e)=>{
		dispatch(editBioData({
			field:'headline',
			value:e.target.value
		}))
	}
	return (
		<div>
			<strong>Headline</strong>
			<Form.Control 
				defaultValue={headline} 
				placeholder="Headline"
				onBlur={handleBlur}
			/>
		</div>
	)
}

const Bio = ()=>{
	const dispatch = useDispatch()

	const bio = useSelector(
		state => state.users.current_user.bio_data.bio
	)

	const handleBlur = e => {
		dispatch(editBioData({
			field:'bio',
			value:e.target.value
		}))
	}
	return (
		<div>
			<strong>Bio</strong>
			<Form.Control 
				defaultValue={bio} 
				placeholder="Bio"
				onBlur={handleBlur}
				as="textarea"
			/>
		</div>
	)
}

const Country = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const [countriesMap,setCountriesMap] = useState({})
	const options = useMemo(
		()=>Object.entries(countriesMap).map(([k,v])=>({value:k,label:v})),
		[countriesMap]
	)

	const zipCode = useSelector(state=>state.users.current_user.bio_data.zipCode)

	const countryId = useSelector(state=>state.users.current_user.bio_data.country)
	const country = {value:countryId,label:countriesMap[countryId]}

	useEffect(()=>{
		envAwarePost('api/users/',{action:'getCountries'}).then(res=>{
			setCountriesMap(res.data.countries)
		})
	},[])

	const handleSelectCountry = (selectedCountry)=>{
		statusDispatch(editBioData({
			field:'country',
			value:selectedCountry.value
		}),'country','edit')
	}

	const handleBlurZip = (e)=>{
		statusDispatch(editBioData({
			field:'zipCode',
			value:e.target.value
		}),'Postal Code','edit')
	}

	return (
		<div>
			<strong>Country</strong>
			<Select
				onChange={handleSelectCountry}
				options={options}
				value={country}
			/>
			{
				//is USA
				parseInt(countryId) === 231 &&
				<>
					<strong>
						Postal Code (US only)
						<OverlayTrigger overlay={
							<Tooltip>
								Enter a US postal code and select in-person training to appear on Findtraingain.com's In-person search (world-wide search to be added in the future)
							</Tooltip>
						}>
							<i className="ml-1 fas fa-info-circle" style={{ marginTop: "5px" }} />
						</OverlayTrigger>
					</strong>
					<Form.Control 
						defaultValue={zipCode}
						onBlur={handleBlurZip}
						placeholder="ZIP or Postal Code" 
					/>
				</>
			}
		</div>
	)
}

const PageDisplayOptions = ()=>{
	const dispatch = useDispatch()
	const options = [
		{
			id:"show-phone-number-check",
			label:"Show Phone Number",
			field:'showPhone',
			checked:useSelector(state=>Boolean(state.users.current_user.bio_data.showPhone))
		},{
			id:"show-email-check",
			label:"Show Email",
			field:'showEmail',
			checked:useSelector(state=>Boolean(state.users.current_user.bio_data.showEmail))
		},{
			id:"show-picture-check",
			label:"Show Picture",
			field:'showPicture',
			checked:useSelector(state=>Boolean(state.users.current_user.bio_data.showPicture))
		},{
			id:"show-client-testimonials-check",
			label:"Show Client Testimonials",
			field:'showClientTestimonials',
			checked:useSelector(state=>Boolean(state.users.current_user.bio_data.showClientTestimonials))
		},{
			id:"show-blogs-check",
			label:"Show Blogs",
			field:'showBlogs',
			checked:useSelector(state=>Boolean(state.users.current_user.bio_data.showBlogs))
		}
	]
	const handleChange = (field,value)=>{
		dispatch(editBioData({field,value}))
	}
	return (
		<div>
			<strong>Personal Page Display</strong>
			<div>
				{options.map(opt=>(
					<Form.Check
						onChange={ e => {
							handleChange(
								opt.field,
								Number(e.target.checked)
							)
						}}
						label={opt.label}
						id={opt.id}
						key={opt.field}
						checked={opt.checked}
					/>
				))}
			</div>
		</div>
	)
}

const Certifications = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const dispatch = useDispatch()

	const {processUpload} = useS3DirectUpload()

	useEffect(()=>{
		dispatch(getTrainerPageHeaders())
		dispatch(getTrainerPagesImages())
	},[])

	const title = useSelector(state=>state.trainerPage.trainerPageHeaders.certifications)
	const certifications = useSelector(state=>state.users.current_user.bio_data.certifications)
	const img = useSelector(state=>state.trainerPage.sectionImages.certifications)
	const [newImg,setNewImg] = useState(null)

	const [savingImage,setSavingImage] = useState(false)

	const handleSaveImage = async ()=>{
		setSavingImage(true)
		const s3Res = await processUpload(newImg)
		dispatch(editTrainerPageImages({
			img:s3Res.payload.url,
			category: 'certifications_img'
		})).then(()=>{
			setSavingImage(false)
			setNewImg(null)
		})
	}

	const handleRestoreDefaultImg = ()=>{
		dispatch(editTrainerPageImages({
			img:'',
			category: 'certifications_img'
		}))
	}
	
	const handleChangeSectionTitle = e => {
		statusDispatch(editTrainerPageHeader({
			title:e.target.value,
			header_type:"certifications_renamed"
		}),'header','edit')
	}

	const handleChangeCertifications = e => {
		statusDispatch(editBioData({
			field:'certifications',
			value:e.target.value
		}),`${title} content`,'edit')
	}

	return (
		<div>
			<strong>Section Title</strong>
			<Form.Control
				defaultValue={title}
				className="mb-2"
				onBlur={handleChangeSectionTitle}
				placeholder="Certifications Title"
			/>
			<small>Section Image</small>
			{(img&&!Boolean(newImg))&&
				<img style={{maxWidth:'200px'}} className="d-block" src={img}/>
			}
			{Boolean(newImg)&&
				<div className="my-2">
					<img 
						style={{maxWidth:'200px'}}
						className="d-block mb-2" 
						src={URL.createObjectURL(newImg)}
					/>
					<Button 
						disabled={savingImage}
						onClick={()=>{setNewImg(null)}}
						variant="outline-danger" 
						size="sm"
					>
						Cancel
					</Button>
					<Button 
						disabled={savingImage}
						onClick={handleSaveImage}
						variant="outline-success"
						className="ml-1"
						size="sm"
					>
						Save {savingImage&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			}
			{(Boolean(img)&&!Boolean(newImg))&&
				<Button 
					className="mt-2"
					onClick={handleRestoreDefaultImg}
					variant="outline-danger" 
					size="sm"
				>
					Restore Default Image
				</Button>
			}
			<Form.File 
				className="mt-2"
				onChange={e=>{
					setNewImg(e.target.files[0])
				}}
				label="Upload Image" 
				custom
			/>
			<small>Section Content</small>
			<Form.Control
				onBlur={handleChangeCertifications}
				placeholder="Certifications Description"
				as="textarea"
				defaultValue={certifications}
			/>
		</div>
	)
}

const Specializations = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const dispatch = useDispatch()

	const {processUpload} = useS3DirectUpload()

	useEffect(()=>{
		dispatch(getTrainerPageHeaders())
		dispatch(getTrainerPagesImages())
	},[])

	const title = useSelector(state=>state.trainerPage.trainerPageHeaders.specialty)
	const specializations = useSelector(state=>state.users.current_user.bio_data.specialty)
	const img = useSelector(state=>state.trainerPage.sectionImages.specialty)
	const [newImg,setNewImg] = useState(null)

	const [savingImage,setSavingImage] = useState(false)

	const handleSaveImage = async ()=>{
		setSavingImage(true)
		const s3Res = await processUpload(newImg)
		dispatch(editTrainerPageImages({
			img:s3Res.payload.url,
			category: 'specializations_img'
		})).then(()=>{
			setSavingImage(false)
			setNewImg(null)
		})
	}

	const handleRestoreDefaultImg = ()=>{
		dispatch(editTrainerPageImages({
			img:'',
			category: 'specializations_img'
		}))
	}
	
	const handleChangeSectionTitle = e => {
		statusDispatch(editTrainerPageHeader({
			title:e.target.value,
			header_type:"specialty_renamed"
		}),'header','edit')
	}

	const handleChangeSpecializations = e => {
		statusDispatch(editBioData({
			field:'specialty',
			value:e.target.value
		}),`${title} content`,'edit')
	}

	return (
		<div>
			<strong>Section Title</strong>
			<Form.Control
				defaultValue={title}
				className="mb-2"
				onBlur={handleChangeSectionTitle}
				placeholder="Title"
			/>
			<small>Section Image</small>
			{(img&&!Boolean(newImg))&&
				<img style={{maxWidth:'200px'}} className="d-block" src={img}/>
			}
			{Boolean(newImg)&&
				<div className="my-2">
					<img 
						style={{maxWidth:'200px'}}
						className="d-block mb-2" 
						src={URL.createObjectURL(newImg)}
					/>
					<Button 
						disabled={savingImage}
						onClick={()=>{setNewImg(null)}}
						variant="outline-danger" 
						size="sm"
					>
						Cancel
					</Button>
					<Button 
						disabled={savingImage}
						onClick={handleSaveImage}
						variant="outline-success"
						className="ml-1"
						size="sm"
					>
						Save {savingImage&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			}
			{(Boolean(img)&&!Boolean(newImg))&&
				<Button 
					className="mt-2"
					onClick={handleRestoreDefaultImg}
					variant="outline-danger" 
					size="sm"
				>
					Restore Default Image
				</Button>
			}
			<Form.File 
				className="mt-2"
				onChange={e=>{
					setNewImg(e.target.files[0])
				}}
				label="Upload Image" 
				custom
			/>
			<small>Section Content</small>
			<Form.Control
				onBlur={handleChangeSpecializations}
				placeholder="Description"
				as="textarea"
				defaultValue={specializations}
			/>
		</div>
	)
}

const Testimonials = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const testimonials = [
		{
			name:useSelector(state=>state.users.current_user.bio_data.client_name_1),
			testimony:useSelector(state=>state.users.current_user.bio_data.client_testimonial_1)
		},{
			name:useSelector(state=>state.users.current_user.bio_data.client_name_2),
			testimony:useSelector(state=>state.users.current_user.bio_data.client_testimonial_2)
		},{
			name:useSelector(state=>state.users.current_user.bio_data.client_name_3),
			testimony:useSelector(state=>state.users.current_user.bio_data.client_testimonial_3)
		}
	]
	const handleUpdateTestimonial = (field,value)=>{
		statusDispatch(editBioData({
			field,value
		}),'testimonial','edit')
	}
	return (
		<div>
			<strong>Client Testimonials</strong>
			<div>
				{testimonials.map((testimony,i)=>(
					<div className="mb-2">
						<small>Testimonial #{i+1}</small>
						<Form.Control 
							onBlur={e=>{
								const field = `client_name_${i+1}`
								const value = e.target.value
								handleUpdateTestimonial(field,value)
							}}
							defaultValue={testimony.name}
							placeholder="Client Name" 
							className="mb-2"
						/>
						<Form.Control 
							onBlur={e=>{
								const field = `client_testimonial_${i+1}`
								const value = e.target.value
								handleUpdateTestimonial(field,value)
							}}
							defaultValue={testimony.testimony}
							placeholder="Client Testimony"
							as="textarea"
						/>
					</div>
				))}
			</div>
		</div>
	)
}

const SocialMediaLinks = ()=>{
	const statusDispatch = useApiStatusDispatch()

	const links = [
		{
			key:'instagram',
			text:'Instagram',
			value:useSelector( state => state.users.current_user.bio_data.instagram_link )
		},{
			key:'youtube',
			text:'YouTube',
			value:useSelector( state => state.users.current_user.bio_data.youtube_link )
		},{
			key:'facebook',
			text:'Facebook',
			value:useSelector( state => state.users.current_user.bio_data.facebook_link )
		},{
			key:'twitter',
			text:'Twitter',
			value:useSelector( state => state.users.current_user.bio_data.twitter_link )
		},{
			key:'linkedin',
			text:'Linkedin',
			value:useSelector( state => state.users.current_user.bio_data.linkedin_link )
		},{
			key:'snapchat',
			text:'Snapchat',
			value:useSelector( state => state.users.current_user.bio_data.snapchat_link )
		},{
			key:'reddit',
			text:'Reddit',
			value:useSelector( state => state.users.current_user.bio_data.reddit_link )
		},{
			key:'tiktok',
			text:'TikTok',
			value:useSelector( state => state.users.current_user.bio_data.tiktok_link )
		}
	]

	const updateSocialLink = (social,value)=>{
		const field = `${social}_link`
		statusDispatch(
			editBioData({field,value}),
			`${capitalize(social)} link`,
			'edit'
		)
	}

	return (
		<div>
			<strong>Social Media Links</strong>
			<div>
				{links.map(link=>(
					<div>
						<small key={link.key}>
							{link.text}
						</small>
						<Form.Control
							onBlur={(e)=>{
								updateSocialLink(link.key,e.target.value)
							}}
							placeholder={capitalize(link.key)}
							defaultValue={link.value}
							size="sm"
						/>
					</div>
				))}
			</div>
		</div>
	)
}

const ContactInfo = ()=>{
	const statusDispatch = useApiStatusDispatch()
	const phone = useSelector(state=>state.users.current_user.user_phone)
	const email = useSelector(state=>state.users.current_user.user_email)
	const handleChangePhone = (e)=>{
		statusDispatch(editBioData({
			field:'phone',
			value:e.target.value
		}),'phone number','edit')
	}
	const handleChangeEmail = (e)=>{
		statusDispatch(editBioData({
			field:'user_email',
			value:e.target.value
		}),'email','edit')
	}
	return (
		<div>
			<strong>Phone Number</strong>
			<Form.Control 
				onBlur={handleChangePhone}
				defaultValue={phone}
				placeholder="Phone Number"
			/>
			<strong>Email</strong>
			<Form.Control 
				onBlur={handleChangeEmail}
				defaultValue={email}
				placeholder="Email"
			/>
		</div>
	)
}

const PageAddress = ()=>{
	const address = useSelector(state=>state.users.current_user.bio_data.pageAddress)
	const dispatch = useDispatch()
	const containsInvalidCharacters = address => {
		//filters out all characters that are not letters, numbers, hyphens or underscores
		const filteredAddress = address.replace(/([^\_,\-,a-zA-Z,0-9])/g, "")
		//if the filtered and non filtered address are not the same then we know that 
		//invalide characters were used
		return filteredAddress !== address
	}
	const [value,setValue] = useState(address)
	const handleBlur = (e)=>{
		const pageAddress = e.target.value
		if(containsInvalidCharacters(pageAddress)) return
		dispatch(editTrainerPageAddress(pageAddress))
	}
	return (
		<div>
			<div>
				<div>
					<strong>Page Address</strong>
				</div>
				<div className="d-flex align-items-center">
					www.fitsw.com/
					<Form.Control 
						style={{width:'200px'}}
						defaultValue={address} 
						onChange={e=>{setValue(e.target.value)}}
						onBlur={handleBlur} 
						size="sm" 
					/>
				</div>
				{containsInvalidCharacters(value)&&
					<small className="text-danger d-block">URL can only contain letters, numbers, hyphens (-) and underscores (_)</small>
				}
				<a target="_blank" href={`/${address}`}>
					View Page as Others See It
				</a>
			</div>
		</div>
	)
}

const LogoOptions = ()=>{
	const hasCustomApp = Boolean(useBranding())
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const logo = useSelector( 
		state => state.users.current_user.bio_data.img 
	)

	const width = useSelector(
		state => state.branding.width
	)

	const [isPending,setIsPending] = useState(false)
	const [newLogo,setNewLogo] = useState(null)

	//const dispatch = useDispatch()
	const handleSelect =  e => {
		setNewLogo(e.target.files[0])
	}

	const {processUpload} = useS3DirectUpload()

	const user = useCurrentUser()
	const pageTypeText = (
		user.account_type === 'gym'
		? 'Gym'
		: 'Trainer'
	)

	const saveCustomWebAppLogo = async ()=>{
		//this code renames the logo so that the upload api returns
		//a signed url for the custom logo
		const extension = newLogo.type.split("/").pop()
		const renamedLogo = new File([newLogo], `customLogo.${extension}`, {
            type: newLogo.type,
            lastModified: newLogo.lastModified,
        })
		const s3Res = await processUpload(renamedLogo)
		dispatch(setLogo(s3Res.payload.url))
	}

	const handleSave = async ()=>{
		setIsPending(true)
		if (hasCustomApp) saveCustomWebAppLogo()
		const s3Res = await processUpload(newLogo)
		statusDispatch(editLogo(s3Res.payload.url),'logo','save')
		.then(()=>{
			clearNewLogo()
			setIsPending(false)
		})
	}

	const handleRestoreDefault = ()=>{
		dispatch(editLogo(''))
	}

	const clearNewLogo = ()=>{
		setNewLogo(null)
	}

	const handleEditLogoWidth = (e)=>{
		statusDispatch(editCustomApp({
			update:{
				width:parseInt(e.target.value) || 180
			}
		}),'custom logo width','edit')
	}

	return (
		<div>
			<strong className="d-block">Website Logo</strong>
			<small>This logo is what will be used on the website</small>
			<div>
				{(Boolean(logo)&&!Boolean(newLogo))&&
					<img 
						src={logo}
						className="d-block" 
						style={{
							maxHeight:'120px',
							maxWidth:'100%'
						}}
					/>
				}
				{Boolean(newLogo)&&
					<img 
						src={URL.createObjectURL(newLogo)}
						className="d-block" 
						style={{
							maxHeight:'120px'
						}}
					/>
				}
				{Boolean(newLogo)&&
					<small className="d-block mt-2">
						{newLogo.name}
					</small>
				}
				<Form.File 
					onChange={handleSelect} 
					label="Add Your Logo Image" 
					className="mt-2"
					custom
				/>
				{Boolean(newLogo)&&
					<div className="justify-content-end d-flex mt-2">
						<Button
							disabled={isPending} 
							onClick={clearNewLogo}
							variant="outline-danger" 
							className="mr-2"
							size="sm"
						>
							Cancel
						</Button>
						<Button 
							disabled={isPending} 
							onClick={handleSave}
							variant="outline-success" 
							size="sm"
						>
							Save {isPending&&<Spinner animation="border" size="sm"/>}
						</Button>
					</div>
				}
				{(hasCustomApp&&Boolean(logo))&&
					<div className="text-right">
						<small>
							Restoring only affects your {pageTypeText} Page.
						</small>
					</div>
				}
				{(Boolean(logo)&&hasCustomApp)&&
					<div>
						<small>
							Logo Width in Pixels (180 recommended)
						</small>
						<Form.Control 
							onBlur={handleEditLogoWidth}
							defaultValue={width}
							placeholder="width"
						/>
					</div>
				}
			</div>
		</div>
	)
}

const validateFileExtension = (filename)=>{
  const allowedExtensions = [".png", ".webp", ".svg"];
  const extension = filename.substring(filename.lastIndexOf("."));
  return allowedExtensions.includes(extension);
}


const PWAOptions = ()=>{
	const statusDispatch = useApiStatusDispatch()

	const {
		pwa_icon_512,
		pwa_name,
		pwa_short_name
	} = useSelector( state => state.branding || {} )

	const {processUpload} = useS3DirectUpload()

	const [newIcon,setNewIcon] = useState(null)
	const handleSelect = e => {
		setNewIcon(e.target.files[0])
	}

	const [iconIsSaving,setIconIsSaving] = useState(false)
	const saveAppIcon = async ()=>{
		if(!validateFileExtension(newIcon.name)){
			window.alert('File must be a PNG, SVG or WebP file type.')
			return
		}
		setIconIsSaving(true)
		const create192Success =  async (icon192)=>{
			//upload both icons to s3
			const icon512URL = (await processUpload(newIcon)).payload.url
			const icon192URL = (await processUpload(icon192)).payload.url
			//save urls
			statusDispatch(editCustomApp({
				update:{
					pwa_icon_512:icon512URL,
					pwa_icon_192:icon192URL,
					has_pwa_icons:1
				}
			}),'custom app icon','save').then(()=>{
				setIconIsSaving(false)
			})
		}

		const validSizeSuccess = async ()=>{
			//upload to s3as
			//create 192x192 image 
			resizeImage({
				file:newIcon,
				dims:{w:192,h:192},
				success:create192Success
			})
		}

		validateImageSize({
			file:newIcon,
			dims:{w:512,h:512},
			success:validSizeSuccess,
			fail:(w,h)=>{
				window.alert(`Image must be exactly 512x512. The image provided was ${w}x${h}.`)
				setIconIsSaving(false)
			}
		})
	}

	const dispatchUpdate = (update)=>{
		statusDispatch(editCustomApp({
			update
		}),'custom app name','save')
	}

	const debouncedDispatchUpdate = useDebounceCallback(
		dispatchUpdate,
		500
	)

	return (
		<div>
			<strong className="d-block">App Name</strong>
			<small>This is the full name of your app/business.</small>
			<Form.Control 
				placeholder="App Name"
				defaultValue={pwa_name}
				onChange={e=>{
					debouncedDispatchUpdate({pwa_name:e.target.value})
				}}
			/>

			<strong className="d-block">App Short Name</strong>
			<small>This is an abbreviated name that will be used on small screens like a smart phone home screen.</small>
			<Form.Control 
				placeholder="App Short Name"
				defaultValue={pwa_short_name}
				onChange={e=>{
					debouncedDispatchUpdate({pwa_short_name:e.target.value})
				}}
			/>

			<strong className="d-block">App Icon</strong>
			<small>This icon <strong>must be file type PNG, SVG or WebP and be 512x512 pixels</strong> and is displayed when clients add your website to their homescreen.</small>
			<div>
				{(Boolean(pwa_icon_512)&&!Boolean(newIcon))&&
					<img 
						src={pwa_icon_512}
						className="d-block" 
						style={{
							maxHeight:'120px',
							maxWidth:'100%'
						}}
					/>
				}
				{Boolean(newIcon)&&
					<img 
						src={URL.createObjectURL(newIcon)}
						className="d-block" 
						style={{
							maxHeight:'120px'
						}}
					/>
				}
				{Boolean(newIcon)&&
					<small className="d-block mt-2">
						{newIcon.name}
					</small>
				}
				<Form.File 
					onChange={handleSelect} 
					label="Add Your App Icon" 
					className="mt-2"
					custom
				/>
				{Boolean(newIcon)&&
					<div className="text-right py-2">
						<Button onClick={()=>{setNewIcon('')}} variant="outline-danger" className="mr-2" size="sm">
							Cancel 
						</Button>
						<Button 
							disabled={iconIsSaving}
							onClick={saveAppIcon} 
							variant="outline-success" 
							size="sm"
						>
							Save New Icon {iconIsSaving&&<Spinner size="sm" animation="border"/>}
						</Button>
					</div>
				}
			</div>
			<div>
				<strong className="d-block">Install Steps</strong>
				<ul>
					<li>
						<strong>Login to your account</strong> - this must be done <em>before</em> adding to home screen or installing 
					</li>
					<li>
						<strong>Click install or add to homescreen</strong> - this depends on your device and browser. 
					</li>
					<li>
						If you do not see your app icon. You may need to clear your device cache and/or restart your device.
					</li>
				</ul>
			</div>
			<hr/>
		</div>
	)
}

const CustomApp = ()=>{

	const hasCustomApp = Boolean(useBranding())

	const dispatch = useDispatch()

	const {
		backgroundColor,
		logo,
		textColor
	} = useSelector( state => state.branding )

	useEffect(()=>{
		dispatch(getCustomAppDetails())
	},[])

	const handleUpdateColor = (field,value)=>{
		dispatch(editCustomApp({update:{[field]:value}}))
	}

	return (
		<div>
			{hasCustomApp&&
				<div>
					<PWAOptions/>
					<strong>Brand Colors</strong>
					<div>
						<small>Background Color</small>
						<OverlayTrigger trigger="click" rootClose overlay={
							<Popover>
								<SketchPicker
									color={backgroundColor||'#000'}
									onChangeComplete={({hex})=>{
										handleUpdateColor('backgroundColor',hex)
									}}
								/>
							</Popover>
						}>
							<div className="border rounded mr-1" style={{
								width:'100%',
								height:'32px',
								background:backgroundColor||'#000'
							}}/>
						</OverlayTrigger>
					</div>
					<div>
						<small>Text Color</small>
						<OverlayTrigger trigger="click" rootClose overlay={
							<Popover>
								<SketchPicker
									color={textColor||'#000'}
									onChangeComplete={({hex})=>{
										handleUpdateColor('textColor',hex)
									}}
								/>
							</Popover>
						}>
							<div className="border rounded mr-1" style={{
								width:'100%',
								height:'32px',
								background:textColor||'#000'
							}}/>
						</OverlayTrigger>
					</div>
				</div>
			}
			{!hasCustomApp&&
				<div>
					<strong>
						You can purchase a custom app for a completely white-labeled experience
					</strong>
					<p>A custom app purchase includes</p>
					<ul>
						<li>Your own logo</li>
						<li>Your own, branded login page</li>
						<li>All features of FitSW.com</li>
						<li>Branded web application interface for you and your clients</li>
					</ul>
					<Button 
						href="/upgradeCustom"
						target="_blank"
						variant="outline-primary" 
						block
					>
						Purchase a Custom App
					</Button>
				</div> 
			}
		</div>
	)
}

const LinkTests = ({links})=>(
    <div className="d-flex mt-2">
        <span className="mr-2">Test links for each device:</span>
        <a 
            target="_blank" 
            href={links.web} 
            rel="noopener noreferrer"
        >
            Web
        </a>
        <span className="mx-2 text-muted">|</span>
        <a 
            target="_blank" 
            href={links.iOS} 
            rel="noopener noreferrer"
        >
            iOS
        </a>
        <span className="mx-2 text-muted">|</span>
        <a 
            target="_blank" 
            href={links.android} 
            rel="noopener noreferrer"
        >
            Android
        </a>
    </div>
)

const AccountLinks = ({accountType})=>{
    const dispatch = useDispatch()
    const [device,setDevice] = useState('web')
    const {[accountType]:links} = useWelcomeLinks()
    const linksDisabled = links.web.enabled === 0
    const [link,setLink] = useState(device === 'all' ? "" : links[device].welcome_link)
    const handleSave = ()=>{
        dispatch(updateWelcomeLinks({
            account_type:accountType,
            device,
            link
        }))
    }
    const handleToggle = e => {
        const enabled = Number(e.target.checked)
        dispatch(toggleWelcomeLinks({
            account_type:accountType,
            enabled
        }))
    }
    return (
        <div>
            <Form.Label>
              <strong>{capitalize(accountType)} Welcome Link:</strong>
            </Form.Label>
            <InputGroup>
                <Form.Control  
                    disabled={linksDisabled}
                    type="text" 
                    value={linksDisabled?"":link} 
                    placeholder="Welcome Link"
                    onChange={ (e) => {
                        setLink(e.target.value)
                    }}
                />
                <Form.Control  
                    onChange={e=>{ 
                        const newDevice = e.target.value
                        const newLink = newDevice === 'all' ? "" : links[newDevice].welcome_link
                        setDevice(newDevice) 
                        setLink(newLink)
                    }}
                    style={{maxWidth:'128px'}}
                    value={device}
                    as="select"
                >
                    <option value="web">Web</option>
                    <option value="iOS">iOS</option>
                    <option value="android">Android</option>
                    <option value="all">All Devices</option>
                </Form.Control>
                <InputGroup.Append>
                    <Button 
                        onClick={handleSave}
                        variant="outline-secondary"
                    >
                        Save
                    </Button>
                </InputGroup.Append>
            </InputGroup>
            <div className="d-flex align-items-center">
                <Form.Check 
                    label={`Enable ${accountType} welcome videos`}
                    id={`toggle-${accountType}-welcome-videos`}
                    checked={!linksDisabled}
                    type="switch"
                    onChange={handleToggle} 
                />
                <small className="ml-2">
                    <Badge pill variant={linksDisabled?'secondary':'success'}>
                       {linksDisabled?'OFF':'ON'}
                    </Badge>
                </small>
            </div>
            <LinkTests links={{
                web:links.web.welcome_link,
                iOS:links.iOS.welcome_link,
                android:links.android.welcome_link
            }}/>
        </div>
    )
}

const WelcomeVideos = ()=>{
    const accountType = useSelector(state => state.users.current_user.account_type);
    const {status} = useWelcomeLinks()
    return (
        <div>
            <div className="flex-column">
                <strong>Welcome Videos</strong>
                <div className="mb-2">
                    Customize the welcome video/link to show when your members first login into the app. 
                    You can customize the video for each device type: web, iOS & android.
                </div>
            </div>
            <hr class="mt-1" />
            { 
                status !== 'idle' ? 
                <CenteredLoader/> :
                <>
                    <AccountLinks accountType="client"/>
                    <hr/>
                    {accountType === "gym" &&
                       <AccountLinks accountType="trainer"/>
                    }
                </>
            }
        </div>

    )
}

const AppCustomization = ()=>{
	const {backgroundColor,textColor,textButtonColor} = useBranding()

	const user = useCurrentUser()
	const pageTypeText = (
		user.account_type === 'gym'
		? 'Gym'
		: 'Trainer'
	)

	const blockGroups = [
		{
			title:'Location, Availability & Contact',
			component:(
				<div>
					<PageAddress/>
					<hr className="my-3"/>
					<Country/>
					<hr className="my-3"/>
					<TrainingOptions/>
					<hr className="my-3"/>
					<ContactInfo/>
					<hr className="my-3"/>
					<SocialMediaLinks/>
				</div>
			)
		},{
			title:'Branding',
			component:(
				<div>
					<Headline/>
					<hr className="my-3"/>
					<Bio/>
					<hr className="my-3"/>
					<LogoOptions/>
					<hr className="my-3"/>
					<CustomApp/>
					<hr className="my-3"/>
					<WelcomeVideos/>
				</div>
			)
		},{
			title:'Lite iOS',
			component:<LiteIOS/>
		},{
			title:'Template Customization',
			component:(
				<div>
					<Templates/>
					<ColorOptions/>
					<PageDisplayOptions/>
				</div>
			)
		},{
			title:`${pageTypeText} Page Content`,
			component:(
				<div>
					<Certifications/>
					<hr className="my-3"/>
					<Specializations/>
					<hr className="my-3"/>
					<Testimonials/>
				</div>
			)
		},{
			title:`${pageTypeText} Page Services`,
			component:<Services/>
		}
	]
	return (
		<div className="pb-5">
			<h4>Personalized Page</h4>
			<p>
				FitSW allows you to create your own free personalized page that you can share with potential or existing clients at www.fitsw.com/<b><i>YourPage</i></b> and it will also be featured on <a id="livePageLink" href="https://www.findtraingain.com" target="_blank" rel="noopener">FindTrainGain.com</a>
				<OverlayTrigger overlay={
					<Tooltip>
						FindTrainGain is a site that helps potential clients find Personal Trainers. To be visible on findtraingain.com's trainer search, make sure to fill out the 'Headline' section and the rest of your profile
					</Tooltip>
				}>
					<i className="ml-1 fas fa-info-circle" style={{ marginTop: "5px" }} />
				</OverlayTrigger>
				<span>
					. After making customizations,
					<i> refresh your personalized {pageTypeText} Page to immediately see updates.</i>
				</span>
			</p>
			<hr className="my-3"/>
			<div id={css.Grid}>
				{blockGroups.map((group,i)=>(
					<div key={i} className={css.GridBlock}>
						<div 
							style={{
								background:backgroundColor,
								color:textColor
							}}
							className="text-center mb-1 p-2"
						>
							<strong>{group.title}</strong>
						</div>
						<div className="p-2">
							{group.component}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default AppCustomization